// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TomogramsGrid.rel {
  position: relative;
  height: 800px;
}
.TomogramsGrid__item {
  position: absolute;
  width: 50%;
  height: 50%;
}
.TomogramsGrid__item:nth-child(1) {
  top: 0;
  left: 0;
}
.TomogramsGrid__item:nth-child(2) {
  top: 0;
  right: 0;
}
.TomogramsGrid__item:nth-child(3) {
  bottom: 0;
  left: 0;
}
.TomogramsGrid__item:nth-child(4) {
  bottom: 0;
  right: 0;
}

.canvasDiv {
  width: 100%;
  height: 100%;
  border: solid 1px gray;
  box-sizing: border-box;
  transition: 0.1s;
  background: black;
}
.canvasDiv canvas {
  transition: 0.2s;
}
.canvasDiv__caption {
  position: absolute;
  bottom: 0;
  left: 0;
  color: rgba(255, 255, 255, 0.7);
  line-height: 20px;
  font-size: 18px;
  padding: 8px;
}
.canvasDiv__fullscreen-icon {
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 4px;
  border-radius: 2px;
}
.canvasDiv__fullscreen-icon > svg {
  display: block;
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
}
.canvasDiv__create-icon {
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: 30px;
  padding: 4px;
  border-radius: 2px;
}
.canvasDiv__create-icon > svg {
  display: block;
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
}
.canvasDiv__create-icon._active {
  background-color: white;
}
.canvasDiv__create-icon._active > svg {
  color: black;
}
.canvasDiv__tomogram {
  background-color: black;
  height: 100% !important;
}
.canvasDiv._inactive {
  z-index: 0;
}
.canvasDiv._active {
  width: 200% !important;
  height: 200% !important;
  z-index: 1;
}

.model {
  position: absolute;
  top: 0;
  left: 0;
}

.axial {
  border: 1px solid red !important;
  position: absolute;
  bottom: 0;
  left: 0;
}

.sagittal {
  border: 1px solid yellow !important;
  position: absolute;
  top: 0;
  right: 0;
}

.coronal {
  border: 1px solid green !important;
  position: absolute;
  bottom: 0;
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/TomogramsGrid/index.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,aAAA;AAAJ;AAGE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AADJ;AAIE;EACE,MAAA;EACA,OAAA;AAFJ;AAKE;EACE,MAAA;EACA,QAAA;AAHJ;AAME;EACE,SAAA;EACA,OAAA;AAJJ;AAOE;EACE,SAAA;EACA,QAAA;AALJ;;AASA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AANF;AAQE;EACE,gBAAA;AANJ;AASE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AAPJ;AAUE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;AARJ;AAUI;EACE,cAAA;EACA,+BAAA;EACA,eAAA;AARN;AAYE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAVJ;AAYI;EACE,cAAA;EACA,+BAAA;EACA,eAAA;AAVN;AAaI;EACE,uBAAA;AAXN;AAcI;EACE,YAAA;AAZN;AAgBE;EACE,uBAAA;EACA,uBAAA;AAdJ;AAiBE;EACE,UAAA;AAfJ;AAkBE;EACE,sBAAA;EACA,uBAAA;EACA,UAAA;AAhBJ;;AAoBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AAjBF;;AAoBA;EACE,gCAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AAjBF;;AAoBA;EACE,mCAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;AAjBF;;AAoBA;EACE,kCAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAjBF","sourcesContent":[".TomogramsGrid {\n  &.rel {\n    position: relative;\n    height: 800px;\n  }\n\n  &__item {\n    position: absolute;\n    width: 50%;\n    height: 50%;\n  }\n\n  &__item:nth-child(1) {\n    top: 0;\n    left: 0;\n  }\n\n  &__item:nth-child(2) {\n    top: 0;\n    right: 0;\n  }\n\n  &__item:nth-child(3) {\n    bottom: 0;\n    left: 0;\n  }\n\n  &__item:nth-child(4) {\n    bottom: 0;\n    right: 0;\n  }\n}\n\n.canvasDiv {\n  width: 100%;\n  height: 100%;\n  border: solid 1px gray;\n  box-sizing: border-box;\n  transition: 0.1s;\n  background: black;\n\n  & canvas {\n    transition: 0.2s;\n  }\n\n  &__caption {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    color: rgba(255, 255, 255, .7);\n    line-height: 20px;\n    font-size: 18px;\n    padding: 8px;\n  }\n\n  &__fullscreen-icon {\n    cursor: pointer;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    padding: 4px;\n    border-radius: 2px;\n\n    & > svg {\n      display: block;\n      color: rgba(255, 255, 255, .7);\n      font-size: 18px;\n    }\n  }\n\n  &__create-icon {\n    cursor: pointer;\n    position: absolute;\n    bottom: 0;\n    right: 30px;\n    padding: 4px;\n    border-radius: 2px;\n\n    & > svg {\n      display: block;\n      color: rgba(255, 255, 255, .7);\n      font-size: 18px;\n    }\n\n    &._active {\n      background-color: white;\n    }\n\n    &._active > svg {\n      color: black;\n    }\n  }\n\n  &__tomogram {\n    background-color: black;\n    height:100%!important;\n  }\n\n  &._inactive {\n    z-index: 0;\n  }\n\n  &._active {\n    width: 200% !important;\n    height: 200% !important;\n    z-index: 1;\n  }\n}\n\n.model {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.axial {\n  border: 1px solid red !important;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.sagittal {\n  border: 1px solid yellow !important;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.coronal {\n  border: 1px solid green !important;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
